import { render, staticRenderFns } from "./DadosPagamento.vue?vue&type=template&id=01818e0a"
import script from "./DadosPagamento.vue?vue&type=script&lang=js"
export * from "./DadosPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports